import { Component, OnInit, Input } from '@angular/core';
import { UserService } from '../../../api/services/user.service';

@Component({
  selector: 'app-user-name',
  templateUrl: './user-name.component.html',
  styleUrls: ['./user-name.component.scss']
})
export class UserNameComponent implements OnInit {

  @Input() userId: string;

  userName = '';
  userIds = [];

  constructor(private userService: UserService) { }


  ngOnInit() {
    this.userIds.push(this.userId);
    this.userService.getUserDisplayNames(this.userIds)
      .subscribe(result => {
        const info = result.find(u => u.userId === this.userId);
        if (info) {
          this.userName = info.displayName;
        } else {
          this.userName = 'N/A';
        }
      });
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/comments/user-name/user-name.component.ts